<template>
    <el-input
        type="text"
        v-if="item.propertyValueType === 0"
        placeholder="请输入"
        @input="$emit('change', $event)"
        :value="value"
        >
        <template slot="append" v-if="hasValueUnit(item)">{{item.valueUnit[0]}}</template>
    </el-input>
    <div v-else>
        <el-input-number
            class="input-number"
            :width="hasValueUnit(item) ? '60%' : '100%'"
            :value="value"
            controls-position="right"
            @change="change"
            :min="item.minValue === '' ? -Infinity : Number(item.minValue)"
            :max="item.maxValue === '' ? Infinity : Number(item.maxValue)"
        >
        </el-input-number>
        <el-select v-if="hasValueUnit(item)" :value="unit" @change="changeUnit" placeholder="请选择" width="40%">
            <el-option
                v-for="v in item.valueUnit"
                :key="v"
                :label="v"
                :value="v">
            </el-option>
        </el-select>
    </div>
</template>

<script>            
export default {
    name: 'pdd-properties-input',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        item: {
            type: Object,
            default() {
                return {}
            }
        },
        value: {
            type: [String, Number],
            default: ''
        },
        valueUnit: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            unit: this.valueUnit
        }
    },
    watch: {
        item: {
            handler(v) {
                if(!this.unit){// 初始化，没有默认值就取valueUnit 里第0个
                    this.unit = (v?.valueUnit && v.valueUnit[0]) || ''
                }
                let units = v.valueUnit.slice(0);
                units = units.filter(u => !!u);
                if (units.length) {
                    this.$emit('changeUnits', {[v.idName]: (this.valueUnit || units[0])});
                }
            },
            immediate: true
        }
    },
    methods: {
        change(val) {
            this.$emit('change', val)
        },
        hasValueUnit(item) {
            if (item.valueUnit) {
                let units = item.valueUnit.slice(0);
                units = units.filter(u => !!u);
                return !!units.length;
            }
            return false;
        },
        changeUnit(val){
            this.unit = val;
            this.$emit('changeUnits', {[this.item.idName]: val});
        }
    }
}
</script>

<style lang="scss">
.input-number {
    .el-input__inner{
        text-align: left;
    }
}
</style>